import React, { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { FaApple, FaAndroid } from 'react-icons/fa'
import { toast } from 'sonner'

const CloseIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
)

const CopyIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
  </svg>
)

const CheckIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <polyline points="20 6 9 17 4 12"></polyline>
  </svg>
)

const InfoIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-1-5h2v2h-2v-2zm0-8h2v6h-2V7z" />
  </svg>
)

const AddToWalletPopup = ({ isOpen, onClose, cardData }) => {


  const [copiedUrl, setCopiedUrl] = useState(null)

  const appleWalletUrl = cardData?.appleWalletPassUrl
  const googleWalletUrl = cardData?.googleWalletPassUrl

  const copyToClipboard = async (url, type) => {
    try {
      if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url)
      } else {
        // Fallback for older browsers or SSR safety
        const textarea = document.createElement('textarea')
        textarea.value = url
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
      }

      setCopiedUrl(type)
      setTimeout(() => setCopiedUrl(null), 2000)
      toast.success('Url Copied Successfully')
    } catch (err) {
      console.error('Failed to copy: ', err)
    }
  }

  const handleAppleWalletAdd = () => {
    if (appleWalletUrl) {
      window.open(appleWalletUrl, '_blank')
    } else {
      console.error('Apple Wallet URL is not available.')
    }
  }

  //   const handleGoogleWalletAdd = () => {
  //     if (googleWalletUrl) {
  //       window.location.href = googleWalletUrl // replaces current tab
  //     } else {
  //       console.error('Google Wallet URL is not available.')
  //     }
  //   }

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40 backdrop-blur-md"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.div
            className="w-full max-w-md max-h-[90vh] overflow-y-auto "
            initial={{ scale: 0.9, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.9, opacity: 0, y: 20 }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="bg-white rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.12)]">
              <div className="flex items-center justify-between p-6 border-b border-gray-100">
                <h2 className="text-xl font-bold text-gray-800">Add to Wallet</h2>
                <button
                  onClick={onClose}
                  className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                >
                  <CloseIcon className="w-5 h-5 text-gray-500" />
                </button>
              </div>

              <div className="p-6 space-y-4">
                <div className="text-center mb-6">
                  <h3 className="text-lg font-semibold text-gray-800 mb-2">
                    {cardData?.businessDetails?.business_name || 'Your Card'}
                  </h3>
                  <p className="text-sm text-gray-600">
                    Add your loyalty card to your digital wallet for quick access
                  </p>
                </div>

                <div className="space-y-3">
                  <div className="border border-gray-200 rounded-xl p-4">
                    <div className="flex items-center gap-3 mb-2">
                      <FaApple className="w-6 h-6 text-gray-700" />
                      <span className="font-medium text-gray-800">Apple Wallet</span>
                    </div>
                    <div className="flex gap-2">
                      <button
                        onClick={handleAppleWalletAdd}
                        className="flex-1 bg-black text-white px-4 py-2 rounded-lg font-medium hover:bg-gray-800 transition-colors cursor-pointer"
                      >
                        Add to Apple Wallet
                      </button>
                      <button
                        onClick={() => copyToClipboard(appleWalletUrl, 'apple')}
                        className="px-3 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer"
                        title="Copy link"
                      >
                        {copiedUrl === 'apple' ? (
                          <CheckIcon className="w-4 h-4 text-green-500" />
                        ) : (
                          <CopyIcon className="w-4 h-4 text-gray-500 " />
                        )}
                      </button>
                    </div>

                    <div className="space-y-3 text-sm text-gray-600 pt-4">
                      <h4 className="font-semibold text-gray-800">Instructions</h4>
                      <div className="border-l-4 border-blue-500 pl-4">
                        <p className="font-medium text-gray-800 mb-1">Step 1:</p>
                        <p>Open the wallet pass link on your iPhone or iPad.</p>
                      </div>
                      <div className="border-l-4 border-blue-500 pl-4">
                        <p className="font-medium text-gray-800 mb-1">Step 2:</p>
                        <p>
                          The Wallet app will open automatically. Tap **"Add"** in the top right
                          corner.
                        </p>
                      </div>
                      <div className="border-l-4 border-blue-500 pl-4">
                        <p className="font-medium text-gray-800 mb-1">Step 3:</p>
                        <p>Your card will appear in the Wallet app, ready to use.</p>
                      </div>
                    </div>
                  </div>

                  <div className="border border-gray-200 rounded-xl p-4">
                    <div className="flex items-center gap-3 mb-2">
                      <FaAndroid className="w-6 h-6 text-green-500" />
                      <span className="font-medium text-gray-800">Google Wallet</span>
                    </div>
                    <div className="flex gap-2">
                      <a
                        href={googleWalletUrl}
                        target="_blank"
                        // rel="noopener noreferrer"
                        className="flex-1 bg-green-600 text-white px-4 py-2 rounded-lg font-medium hover:bg-green-700 transition-colors cursor-pointer"
                      >
                        Add to Google Wallet
                      </a>
                      <button
                        onClick={() => copyToClipboard(googleWalletUrl, 'google')}
                        className="px-3 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer"
                        title="Copy link"
                      >
                        {copiedUrl === 'google' ? (
                          <CheckIcon className="w-4 h-4 text-green-500" />
                        ) : (
                          <CopyIcon className="w-4 h-4 text-gray-500" />
                        )}
                      </button>
                    </div>

                    <div className="space-y-3 text-sm text-gray-600 pt-4">
                      <h4 className="font-semibold text-gray-800">Instructions</h4>
                      <div className="border-l-4 border-green-500 pl-4">
                        <p className="font-medium text-gray-800 mb-1">Step 1:</p>
                        <p>Ensure you have the Google Wallet app installed on your device.</p>
                      </div>
                      <div className="border-l-4 border-green-500 pl-4">
                        <p className="font-medium text-gray-800 mb-1">Step 2:</p>
                        <p>Open the wallet pass link. Google Wallet will prompt you to save it.</p>
                      </div>
                      <div className="border-l-4 border-green-500 pl-4">
                        <p className="font-medium text-gray-800 mb-1">Step 3:</p>
                        <p>Follow the on-screen instructions to save the card to your wallet.</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                  <div className="flex items-start gap-2">
                    <InfoIcon className="w-4 h-4 text-blue-700 mt-1" />
                    <p className="text-xs text-blue-700">
                      To make things easy, we have automatically opened the link for you in a new
                      tab.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default AddToWalletPopup
